import { ApiCore } from "../utilities/ApiCore";

const url = 'eventos';
const single = 'evento';
const plural = 'eventos'

const apiEventos = new ApiCore({
    getSingle: true,
    getAll: true,
    post: true,
    put: true,
    delete: true,
    url: url,
    single: single,
    plural: plural
})

export default apiEventos;


